export const SET_AUTH = 'setUser';
export const SET_LOGOUT = 'setLogout';
export const SET_RESPONSE = 'setResponse';
export const SET_PERMISSION = "setPermission";
export const SET_AUTH_STUDENT = 'setAuthStudent';
export const SET_STUDENT = "setStudent";
export const SET_LOGOUT_STUDENT = "setLogoutStudent";